// extracted by mini-css-extract-plugin
export default {"divider":"FeedbackModal_divider__RbyPC"};